export default __webpack_public_path__ + "static/media/2024.404cc905.png";